import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';
import { UserApiService } from '../services/user-api.service';
import { languageSet } from '../language';
import { TogetherLoginDto } from '../dto/togethe-login.dto';

@Component({
  selector: 'app-launch-together',
  templateUrl: './launch-together.component.html',
  styleUrls: ['./launch-together.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LaunchTogetherComponent implements OnInit {

  togetherLoginDto: TogetherLoginDto | undefined;

  news: any;
  userData: any;
  myLanguage = languageSet.de;
  browserLocale = window.navigator.language;
  error = '';

  constructor(
    public oidcSecurityService: OidcSecurityService,
    private userApiService: UserApiService
  ) { }

  ngOnInit(): void {
    document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'visible';
    this.oidcSecurityService.userData$.subscribe({
      next: (userData) => {
        this.userData = userData.userData;
        this.launchTogetherCheck();
      },
      error: (err) => {
        console.error(err);
      }
    })
  }

  launchTogetherCheck(): void {
    document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'visible';
    this.userApiService.launchTogetherLogin().subscribe({
      next: (togetherLoginDto) => {
        this.togetherLoginDto = togetherLoginDto;
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';

        if (togetherLoginDto.status && togetherLoginDto.status === 200 && togetherLoginDto.whitelisted && togetherLoginDto.message && togetherLoginDto.message === 'User is whitelisted') {
          window.location.href = 'https://www.servicebytogether.at/identity.server/account/login?loginScheme=oidc-efs&returnUrl=/hybridgui/start.jsf';
        }
      },
      error: (err) => {
        this.error = 'failed_to_launch_together_login';
        console.error(err);
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';
      }
    });
  }
}
